import './styles.css';
import { createApp } from './app';
import { createRingtone } from './audio/ringtone';
import { createCallLog } from './calllog/calllog';
import { loadConfig } from './config';
import { createCredentialStore } from './credentials';
import { createJsSipUA } from './sip/jssip-ua';
import { createPhone } from './sip/phone';
import { createStore } from './state/store';
import { renderLogin } from './ui/login';
import { renderPhoneView } from './ui/phone-view';

const storage = (get: () => Storage): Storage | null => {
  try {
    return get();
  } catch {
    return null;
  }
};

const config = loadConfig();
const store = createStore();
const callLog = createCallLog(storage(() => window.localStorage));
const credentials = createCredentialStore(storage(() => window.localStorage), storage(() => window.sessionStorage));
const phone = createPhone({ config, createUA: createJsSipUA });
const audio = document.querySelector<HTMLAudioElement>('#remote-audio')!;
const ringtone = createRingtone();
// Nach automatischer Anmeldung gab es noch keine Nutzergeste: Audio bei der ersten Geste freischalten.
const unlockAudio = () => ringtone.unlock();
for (const type of ['pointerdown', 'keydown'] as const) window.addEventListener(type, unlockAudio, { once: true, capture: true });
const app = createApp({
  config,
  phone,
  store,
  callLog,
  credentials,
  ringtone,
  audioSink: (stream) => {
    audio.srcObject = stream;
    void audio.play().catch(() => undefined);
  },
});

const root = document.querySelector<HTMLDivElement>('#app')!;
let loggedIn: boolean | null = null;
store.subscribe((s) => {
  if (s.session.loggedIn === loggedIn) return;
  loggedIn = s.session.loggedIn;
  if (loggedIn) renderPhoneView(root, app, store, callLog);
  else renderLogin(root, app, store);
});
renderLogin(root, app, store);
loggedIn = false;
app.start();
